export default {
  created() {
    if (!this.filter || typeof this.filter !== "function") {
      throw new Error(
        "Components using listFilterMixin must define a filter function"
      );
    }
  },
  data() {
    return {
      filterString: "",
      // Split on space, comma, semicolon, or tab
      filterTermSeparator: /[\s,;\t]/,
    };
  },
  methods: {
    updateEntityListFiltered(filterString) {
      const { entityListFormatted } = this;

      if (!filterString || filterString === "") {
        this.$emit("update-entity-list-filtered", entityListFormatted);
        return;
      }

      this.$emit(
        "update-entity-list-filtered",
        this.filter(entityListFormatted, filterString)
      );
    },
  },
  props: {
    entityListFormatted: {
      required: true,
      type: Array,
    },
    filterMode: {
      required: true,
      type: Number,
    },
    filterName: {
      required: true,
      type: Number,
    },
  },
  watch: {
    filterMode: function (updatedFilterMode) {
      const { filterName, filterString } = this;

      if (filterName !== updatedFilterMode) {
        return;
      }

      this.updateEntityListFiltered(filterString);
    },
  },
};
